import { render, staticRenderFns } from "./CaptureImage.vue?vue&type=template&id=1ba8e20d"
import script from "./CaptureImage.vue?vue&type=script&lang=js"
export * from "./CaptureImage.vue?vue&type=script&lang=js"
import style0 from "./CaptureImage.vue?vue&type=style&index=0&id=1ba8e20d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports